import { createTheme } from '@mui/material/styles';

// Import fonts
import '@fontsource/roboto';
import '@fontsource/open-sans';
import '@fontsource/lato';
import '@fontsource/montserrat';

const theme = createTheme({
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif', // Default font
  },

  palette: {
    primary: {
      main: '#4285F4',
    },
    secondary: {
      main: '#42F456',
    },
    background: {
      default: '#f5f5f5', // Light grey background
      paper: '#FFFFFF', // This is usually the background for components like Card, Paper, etc.
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#f5f5f5', // Ensure body background is also set
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#FFFFFF', // Set AppBar background to white
        },
      },
    },
  },
});

export default theme;
